import icon from '../../assets/svg/邀请推广.svg';
import type { RouteConfig } from '@/types/route';

export const routeConfig: RouteConfig = {
    title: 'route.invitationPromotion',
    icon:  <img src={icon} alt="Invitation Promotion" className="w-4 h-4" />,
    layout: true,
    sort: 3
};